export function StatGroup({ title, children }) {
  return (
    <div className="bg-white border border-border rounded-xl p-6">
      {title && <p className="text-sm font-semibold mb-5">{title}</p>}
      <div className="flex flex-wrap gap-y-6 divide-x divide-border overflow-x-auto">
        {children}
      </div>
    </div>
  );
}
